import {
  AnalyzeClauseVarianceResponseDto,
  WorkspaceDetailsDto,
  WorkspaceDocumentDto,
  WorkspaceDto,
} from '../models/workspaces.model';
import { DocumentProcessingPagedReviewResponse } from '../../documents/services/document-processing-api.service';

export interface WorkspaceState {
  workspaces: WorkspaceDto[] | null;
  loadingworkspaces: boolean;
  creatingWorkspace: boolean;
  closeCreatingWorkspaceModal: boolean;
  deletingWorkspace: boolean;
  workspaceDetails: WorkspaceDetailsDto | null;
  referenceDocument: WorkspaceDocumentDto | null;
  nonReferenceDocuments: WorkspaceDocumentDto[] | null;
  loadingWorkspaceDetails: boolean;
  renaminWorkspace: boolean;
  closeRenamingWorkspaceModal: boolean;
  addingWorkspaceDocuments: boolean;
  closeAddingWorkspaceDocumentsModal: boolean;
  analyzingClauseVariance: boolean;
  analyzingClauseVarianceResponse: AnalyzeClauseVarianceResponseDto | null;
  reviewDoneWithErrors: boolean;
  loadingReviewData: boolean;
  loadingReviewDataComplete: boolean;
  currentReviewPageByDocumentId: Record<string, number>;
  totalReviewPagesByDocumentId: Record<string, number>;
  reviewedReviewPagesByDocumentId: Record<string, number>;
  pagedReviewDataByDocumentId: Record<string, DocumentProcessingPagedReviewResponse>;
  totalReviewPagesAllDocuments: number;
  totalReviewedPagesAllDocuments: number;
}

export const initialState: WorkspaceState = {
  workspaces: null,
  loadingworkspaces: false,
  creatingWorkspace: false,
  closeCreatingWorkspaceModal: false,
  deletingWorkspace: false,
  workspaceDetails: null,
  referenceDocument: null,
  nonReferenceDocuments: null,
  loadingWorkspaceDetails: false,
  renaminWorkspace: false,
  closeRenamingWorkspaceModal: false,
  addingWorkspaceDocuments: false,
  closeAddingWorkspaceDocumentsModal: false,
  analyzingClauseVariance: false,
  analyzingClauseVarianceResponse: null,
  reviewDoneWithErrors: false,
  loadingReviewData: false,
  loadingReviewDataComplete: false,
  currentReviewPageByDocumentId: {},
  totalReviewPagesByDocumentId: {},
  reviewedReviewPagesByDocumentId: {},
  pagedReviewDataByDocumentId: {},
  totalReviewPagesAllDocuments: 0,
  totalReviewedPagesAllDocuments: 0,
};
